module.exports = __webpack_public_path__ + "img/support.93cc4e67.webp";